import { PushNotificationsComponent } from './../../pages/admin/push-notifications/push-notifications.component';
import { ListingComponent as AudioListing, ViewComponent as AudioView, CreateComponent as AudioCreate } from './../../pages/admin/resources/audio-pods';
import { ListingComponent as ScienceListing, ViewComponent as ScienceView, CreateComponent as ScienceCreate } from './../../pages/admin/resources/science';
import { ListingComponent as CommunityListing, ViewComponent as CommunityView, CreateComponent as CommunityCreate } from './../../pages/admin/resources/community';
import { SeriesEditComponent } from './../../pages/admin/series/edit/edit.component';
import { BillingHistoryComponent } from './../../pages/admin/billing-history/billing-history.component';
import { DeviceOrderComponent } from './../../pages/admin/device-order/device-order.component';
import { UserComponent } from './../../pages/admin/user/user.component';
import { OrganisationListingComponent } from './../../pages/admin/organisation/listing/listing.component';
import { OrganisationEditComponent } from './../../pages/admin/organisation/edit/edit.component';
import { SeriesListingComponent } from './../../pages/admin/series/listing/listing.component';
import { ChallengeReportComponent } from './../../pages/admin/challenge-report/challenge-report.component';
import { DashboardComponent } from './../../pages/admin/dashboard/dashboard.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    data: { title: 'Dashboard' }
  },
  {
    path: 'series',
    component: SeriesListingComponent,
    data: { title: 'Series & Modules' },
  },
  {
    path: 'series/:seriesId/:sequenceNo',
    component: SeriesEditComponent,
    data: { title: 'Series & Modules' }
  },
  {
    path: 'organisations',
    component: OrganisationListingComponent,
    data: { title: 'Enterprises' }
  },
  {
    path: 'organisation-edit/:organisationId',
    component: OrganisationEditComponent,
    data: { title: 'Enterprise Edit' }
  },
  {
    path: 'users',
    component: UserComponent,
    data: { title: 'Users' }
  },
  {
    path: 'device-orders',
    component: DeviceOrderComponent,
    data: { title: 'Device Orders' }
  },
  {
    path: 'billing-history',
    component: BillingHistoryComponent,
    data: { title: 'Billing History' }
  },
  {
    path: 'challenge-report',
    component: ChallengeReportComponent,
    data: { title: '7-Day Challenge Results' }
  },
  {
    path: 'resources',
    children: [
      {
        path: 'audio-pods',
        component: AudioListing,
        data: { title: 'Audio Pods' }
      },
      {
        path: 'audio-pods/:id',
        component: AudioView,
        data: { title: 'Audio Pods' }
      },
      {
        path: 'audio-pods/create/new',
        component: AudioCreate,
        data: { title: 'Audio Pods' }
      },
      {
        path: 'community',
        component: CommunityListing,
        data: { title: 'Community' }
      },
      {
        path: 'community/:id',
        component: CommunityView,
        data: { title: 'Community' }
      },
      {
        path: 'community/create/new',
        component: CommunityCreate,
        data: { title: 'Community' }
      },
      {
        path: 'science',
        component: ScienceListing,
        data: { title: 'Science' }
      },
      {
        path: 'science/:id',
        component: ScienceView,
        data: { title: 'Science' }
      },
      {
        path: 'science/create/new',
        component: ScienceCreate,
        data: { title: 'Science' }
      },
    ],
  },
  {
    path: 'push-notifications',
    component: PushNotificationsComponent,
    data: { title: 'Push Notifications' }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
